import React from 'react';
import Select from '../Select/index.js';
import Slider from '../Slider/index.js';
/* eslint-disable react/prop-types */
const SelectWidget = ({ options, onChange, value, onBlur, defaultValue, tabIndex, onFocus, 'aria-invalid': ariaInvalid, ...rest }) => (React.createElement(Select, { options: options.enumOptions, onChange: (option) => {
        onChange(option?.value);
    }, value: options.enumOptions.find((option) => option.value === value), ...rest }));
const RangeWidget = (({ schema, disabled, label, // eslint-disable-line
options, // eslint-disable-line
formContext, // eslint-disable-line
registry, // eslint-disable-line
...rest }) => (React.createElement(Slider, { ...rest, disabled: disabled, min: schema.minimum, max: schema.maximum, withValue: true })));
export default { SelectWidget, RangeWidget };
